import { Button } from 'ui';
import { useExportMediaMutation } from 'features/media';

type P = {
  fileIds: string[];
};

const SaveZipButton = ({ fileIds }: P) => {
  const { isPending: isLoading, mutate: handleSaveZip } = useExportMediaMutation();

  return (
    <Button
      loading={isLoading}
      onClick={(event) => {
        event.preventDefault();
        handleSaveZip({ fileName: 'Attachments.zip', ids: fileIds });
      }}
      type="link-primary"
    >
      Save all
    </Button>
  );
};

export default SaveZipButton;
